import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = { class: "sidebar-logo" };
const _hoisted_2 = {
    key: 0,
    class: "logo-text"
};
const _hoisted_3 = { class: "sidebar-nav" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "nav-icon" };
const _hoisted_6 = {
    key: 0,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_7 = {
    key: 1,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_8 = {
    key: 2,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_9 = {
    key: 3,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_10 = {
    key: 4,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_11 = {
    key: 5,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_12 = {
    key: 0,
    class: "nav-label"
};
const _hoisted_13 = { class: "sidebar-footer" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { class: "main-wrapper" };
const _hoisted_16 = { class: "topbar" };
const _hoisted_17 = { class: "topbar-left md-hidden" };
const _hoisted_18 = { class: "page-breadcrumb" };
const _hoisted_19 = { class: "breadcrumb-current" };
const _hoisted_20 = { class: "topbar-right" };
const _hoisted_21 = { class: "topbar-time" };
const _hoisted_22 = { class: "content-area" };
const _hoisted_23 = { class: "mobile-nav-tabs md-show" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
    key: 0,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_26 = {
    key: 1,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_27 = {
    key: 2,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_28 = {
    key: 3,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_29 = {
    key: 4,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_30 = {
    key: 5,
    viewBox: "0 0 24 24",
    fill: "none"
};
const _hoisted_31 = { class: "mobile-nav-label" };
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElButton } from 'element-plus';
import { useLogin } from '@/composables/useLogin';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PosLayout',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const { handleLogout } = useLogin();
        const collapsed = ref(false);
        const mobileMenuOpen = ref(false);
        const menuItems = [
            {
                key: 'dashboard',
                label: '今日概览',
                icon: 'dashboard',
                path: '/dashboard',
            },
            {
                key: 'pos',
                label: '点餐操作',
                icon: 'pos',
                path: '/pos',
            },
            {
                key: 'orders',
                label: '订单管理',
                icon: 'orders',
                path: '/orders',
            },
            {
                key: 'members',
                label: '会员管理',
                icon: 'members',
                path: '/members',
            },
            {
                key: 'finance',
                label: '财务管理',
                icon: 'finance',
                path: '/finance',
            },
            {
                key: 'settings',
                label: '系统设置',
                icon: 'settings',
                path: '/settings',
            },
        ];
        const activeKey = computed(() => {
            const path = route.path;
            const item = menuItems.find(m => path.startsWith(m.path));
            return item?.key || 'dashboard';
        });
        const handleNav = (path) => {
            router.push(path);
        };
        const toggleCollapse = () => {
            collapsed.value = !collapsed.value;
        };
        return (_ctx, _cache) => {
            const _component_RouterView = _resolveComponent("RouterView");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["pos-layout-shell", { 'is-collapsed': collapsed.value, 'menu-open': mobileMenuOpen.value }])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["mobile-overlay", { 'is-visible': mobileMenuOpen.value }]),
                    onClick: _cache[0] || (_cache[0] = ($event) => (mobileMenuOpen.value = false))
                }, null, 2),
                _createElementVNode("aside", {
                    class: _normalizeClass(["sidebar", { 'mobile-open': mobileMenuOpen.value }])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "logo-icon" }, [
                            _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                            }, [
                                _createElementVNode("path", {
                                    d: "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13z",
                                    fill: "currentColor"
                                }),
                                _createElementVNode("path", {
                                    d: "M12 6.5c-1.5-1.5-3.5-2-5-2V2h1v2.5c1.5 0 3 1 4.5 2.5S16 10 16 12h-2c0-1.5-1-3-2.5-4.5",
                                    fill: "currentColor"
                                })
                            ])
                        ], -1)),
                        _createVNode(_Transition, { name: "fade" }, {
                            default: _withCtx(() => [
                                (!collapsed.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, "餐饮管理"))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("nav", _hoisted_3, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
                            return _createElementVNode("div", {
                                key: item.key,
                                class: _normalizeClass(["nav-item", { 'is-active': activeKey.value === item.key }]),
                                onClick: ($event) => (handleNav(item.path))
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    (item.icon === 'dashboard')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                                                _createElementVNode("rect", {
                                                    x: "3",
                                                    y: "3",
                                                    width: "7",
                                                    height: "7",
                                                    rx: "1.5",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1),
                                                _createElementVNode("rect", {
                                                    x: "14",
                                                    y: "3",
                                                    width: "7",
                                                    height: "7",
                                                    rx: "1.5",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1),
                                                _createElementVNode("rect", {
                                                    x: "3",
                                                    y: "14",
                                                    width: "7",
                                                    height: "7",
                                                    rx: "1.5",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1),
                                                _createElementVNode("rect", {
                                                    x: "14",
                                                    y: "14",
                                                    width: "7",
                                                    height: "7",
                                                    rx: "1.5",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    (item.icon === 'pos')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[3] || (_cache[3] = [
                                                _createElementVNode("rect", {
                                                    x: "2",
                                                    y: "5",
                                                    width: "20",
                                                    height: "14",
                                                    rx: "2",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M8 19h8M12 15v4",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M6 9h12",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                }, null, -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    (item.icon === 'orders')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                                                _createElementVNode("path", {
                                                    d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                }, null, -1),
                                                _createElementVNode("rect", {
                                                    x: "9",
                                                    y: "3",
                                                    width: "6",
                                                    height: "4",
                                                    rx: "1",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M9 12h6M9 16h4",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                }, null, -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    (item.icon === 'members')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[5] || (_cache[5] = [
                                                _createElementVNode("circle", {
                                                    cx: "9",
                                                    cy: "7",
                                                    r: "4",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M16 3.13a4 4 0 0 1 0 7.75",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M21 21v-2a4 4 0 0 0-3-3.85",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                }, null, -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    (item.icon === 'finance')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                                                _createElementVNode("path", {
                                                    d: "M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                }, null, -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    (item.icon === 'settings')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[7] || (_cache[7] = [
                                                _createElementVNode("circle", {
                                                    cx: "12",
                                                    cy: "12",
                                                    r: "3",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2"
                                                }, null, -1)
                                            ]))]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createVNode(_Transition, { name: "fade" }, {
                                    default: _withCtx(() => [
                                        (!collapsed.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.label), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1024)
                            ], 10, _hoisted_4);
                        }), 64))
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", {
                            class: "collapse-btn",
                            onClick: toggleCollapse
                        }, [
                            (_openBlock(), _createElementBlock("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                style: _normalizeStyle({ transform: collapsed.value ? 'rotate(180deg)' : '' })
                            }, [...(_cache[8] || (_cache[8] = [
                                    _createElementVNode("path", {
                                        d: "M15 18l-6-6 6-6",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                    }, null, -1)
                                ]))], 4)),
                            _createVNode(_Transition, { name: "fade" }, {
                                default: _withCtx(() => [
                                    (!collapsed.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "收起菜单"))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ], 2),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("header", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(menuItems.find(m => m.key === activeKey.value)?.label), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(new Date().toLocaleString('zh-CN', { month: '2-digit', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit' })), 1),
                            _createVNode(_unref(ElButton), {
                                type: "danger",
                                size: "small",
                                onClick: _unref(handleLogout)
                            }, {
                                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createTextVNode(" 退出登录 ", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["onClick"])
                        ])
                    ]),
                    _createElementVNode("main", _hoisted_22, [
                        _createVNode(_component_RouterView)
                    ])
                ]),
                _createElementVNode("nav", _hoisted_23, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
                        return _createElementVNode("div", {
                            key: item.key,
                            class: _normalizeClass(["mobile-nav-tab", { 'is-active': activeKey.value === item.key }]),
                            onClick: ($event) => (handleNav(item.path))
                        }, [
                            (item.icon === 'dashboard')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_25, [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("rect", {
                                            x: "3",
                                            y: "3",
                                            width: "7",
                                            height: "7",
                                            rx: "1.5",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1),
                                        _createElementVNode("rect", {
                                            x: "14",
                                            y: "3",
                                            width: "7",
                                            height: "7",
                                            rx: "1.5",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1),
                                        _createElementVNode("rect", {
                                            x: "3",
                                            y: "14",
                                            width: "7",
                                            height: "7",
                                            rx: "1.5",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1),
                                        _createElementVNode("rect", {
                                            x: "14",
                                            y: "14",
                                            width: "7",
                                            height: "7",
                                            rx: "1.5",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            (item.icon === 'pos')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_26, [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("rect", {
                                            x: "2",
                                            y: "5",
                                            width: "20",
                                            height: "14",
                                            rx: "2",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            d: "M8 19h8M12 15v4",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            d: "M6 9h12",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        }, null, -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            (item.icon === 'orders')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_27, [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("path", {
                                            d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        }, null, -1),
                                        _createElementVNode("rect", {
                                            x: "9",
                                            y: "3",
                                            width: "6",
                                            height: "4",
                                            rx: "1",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            d: "M9 12h6M9 16h4",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        }, null, -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            (item.icon === 'members')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_28, [...(_cache[13] || (_cache[13] = [
                                        _createElementVNode("circle", {
                                            cx: "9",
                                            cy: "7",
                                            r: "4",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            d: "M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            d: "M16 3.13a4 4 0 0 1 0 7.75",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            d: "M21 21v-2a4 4 0 0 0-3-3.85",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        }, null, -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            (item.icon === 'finance')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_29, [...(_cache[14] || (_cache[14] = [
                                        _createElementVNode("path", {
                                            d: "M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        }, null, -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            (item.icon === 'settings')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_30, [...(_cache[15] || (_cache[15] = [
                                        _createElementVNode("circle", {
                                            cx: "12",
                                            cy: "12",
                                            r: "3",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        }, null, -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(item.label), 1)
                        ], 10, _hoisted_24);
                    }), 64))
                ])
            ], 2));
        };
    }
});
